import React from "react";
import { Image as ImageIcon } from "lucide-react";

const BASE_IMAGE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

const ImageDisplay = ({ image, parent_Id }) => {
  const cardWrapperClass = `relative overflow-hidden ${parent_Id === null ? "h-[100svh]" : "sm:h-[70svh]"
    }`;
  //console.log(image);
  const imageClass = `w-full h-full ${parent_Id === null ? "object-contain sm:object-cover" : "object-cover"
    }`;
  //console.log(parent_Id);
  if (!image) {
    return (
      <div className={cardWrapperClass}>
        <div className="text-gray-500 text-lg">No Image</div>
      </div>
    );
  }

  return (
    <div className={cardWrapperClass}>
      {/* 🏷️ Image Tag */}
      <div className="absolute top-[2svh] left-[1.5svh] flex items-center gap-2 bg-indigo-100 text-indigo-800 px-[2svh] py-[0.5svh] rounded-full shadow-sm z-20">
        <ImageIcon className="w-[3.2svh] h-auto" />
        <span className="font-semibold text-[2.3svh] uppercase">Image</span>
      </div>

      {/* 🖼️ Display Image or Fallback Text */}
      {image.image_Path ? (
        <img
          src={`${BASE_IMAGE_URL}/${image.image_Path}`}
          alt={image.image_Cat || `Image ${image.id}`}
          className={imageClass}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-white">
          <p className="text-black text-2xl font-bold">
            {image.image_Cat || "Unnamed Image"}
          </p>
        </div>
      )}
    </div>
  );
};

export default ImageDisplay;